
import { Box, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React from 'react';
import UserAddressOption from '../models/UserAddressOption';
import UserAddressOptionBaseButton from './UserAddressOptionBaseButton';

interface UserAddressOptionListItemProps {
    title: string;
    icon: React.ReactNode;
    value: UserAddressOption;
    selectedValue: UserAddressOption;
    onClick: (userAddressOption: UserAddressOption) => void;
}

const UserAddressOptionListItem: React.FC<UserAddressOptionListItemProps> = observer(({ title, icon, value, selectedValue, onClick }) => {
    return (
        <UserAddressOptionBaseButton value={value} selectedValue={selectedValue} onClick={onClick} icon={icon} title={title}>
        </UserAddressOptionBaseButton>
    )
})

export default UserAddressOptionListItem;